const COLORS = {
    default:"#00394c",
    white:"#fff",
    black:"#24303f",
    gray:"#696969",
    error:"#FF3B30",
    darkGray:"#858585",
    light_gray:"#B9B9B9",    
    light_gray_1:"#E9E9E9",    
    light_green_1:"#E0F2E9",    
    light_pink_1:"#FFE4E1",    
    light:"#F7F7F7",
    deepBlue:"#00416A",
    darkBlue:"#0092CC",
    darkBlue_1:"#03055b",
    dark:"#24303f",
    secondary:"#24303f",
    primary:"#00BFFF",
    // primary:"#1E90FF",
    // primary:"#87CEEB",
    primary_light: "#99e5ff",
    primary_light_1: "#e6f9ff",
    primary_light_2: "#e6f9ff",
    primary_light_3: "#f9feff",
    backgroundColor:"#f9fdff",
    red: 'red',
    twitter_blue:"#1DA1F2",
    twitter_blue:"#1DA1F2",
    verified:"#50C878",
    light_purple_1:"#E0B0FF",
    light_purple_2:"#CCCCFF",
    pink:"#FFC0CB",
    lime_green:"#32CD32",
    spring_green:"#00FF7F",
    green:"#006400",
    purple:"#800080",
    warning:"#FED8B1"
}

export default COLORS